// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Pk0","name":"styles_name__3QiEf","phone":"styles_phone__2anPn"};